import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators } from '@angular/forms';
import Hls from 'hls.js';
import flvjs from 'flv.js';
import axios from 'src/app/Service/axios';
import axios_2 from 'src/app/Service/axios-dotone';
import moment from 'moment-jalaali';
import momentJalaali from 'moment-jalaali';
import { VoiceRecordModalComponent } from './components/voice-record-modal/voice-record-modal.component';
declare let $: any;

@Component({
  selector: 'video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css'],
})
export class VideoPlayerComponent implements OnInit {
  @Input() isHideInfo: boolean = false;
  @Input() src!: string;
  @Input() maxHeight: string = 'initial';
  @Input() obj_Cam!: any;
  @Input() expiresAt!: number;
  @Input() tripId!: number;
  @Input() ScreenShot!: boolean;
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('voiceRecordModal') voiceRecordModal!: VoiceRecordModalComponent;

  isPlaying = false;
  bEditMode: boolean = false;
  private hls?: Hls;
  private flvPlayer?: flvjs.Player;

  mdlTempAccess: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strPassword: new FormControl('', Validators.required),
  });

  constructor(
    private tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: Router,

    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    if (this.expiresAt) {
      const targetTime = this.expiresAt * 1000;

      const now = Date.now();

      const delay = targetTime - now;

      if (delay > 0) {
        setTimeout(() => {
          this.terminateStreaming();
        }, delay);
      } else {
        this.terminateStreaming();
      }
    }

    if (this.obj_Cam?.strUnitId && this.obj_Cam.strUnitId.includes('-')) {
      this.mdlTempAccess.controls['strUnitID'].setValue(
        this.obj_Cam.strUnitId.split('-')[0],
      );
    } else {
      this.mdlTempAccess.controls['strUnitID'].setValue(this.obj_Cam.strUnitID);
    }

    $('.clockpicker').clockpicker({
      donetext: 'top',

      align: 'top',

      autoclose: true,
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.togglePlay();
    }, 400);

    const video = this.videoRef.nativeElement;

    video.muted = true;

    if (this.src.endsWith('.m3u8')) {
      if (Hls.isSupported() && !this.isIOS()) {
        this.hls = new Hls();

        this.hls.loadSource(this.src);

        this.hls.attachMedia(video);
      } else {
        video.src = this.src;

        video.setAttribute('playsinline', 'true');

        video.setAttribute('webkit-playsinline', 'true');
      }
    } else if (this.src.endsWith('.flv')) {
      if (flvjs.isSupported()) {
        this.flvPlayer = flvjs.createPlayer({ type: 'flv', url: this.src });

        this.flvPlayer.attachMediaElement(video);

        this.flvPlayer.load();
      } else {
        video.src = this.src;

        video.muted = true;
      }
    } else {
      video.src = this.src;
    }
  }

  ngOnDestroy(): void {
    if (this.hls) {
      this.hls.destroy();
    }

    if (this.flvPlayer) {
      this.flvPlayer.destroy();
    }
  }

  private isIOS(): boolean {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window)
    );
  }

  togglePlay() {
    const video = this.videoRef.nativeElement;

    if (video.paused) {
      video.play();

      this.isPlaying = true;
    } else {
      video.pause();
      this.isPlaying = false;
    }
  }

  openVoiceRecordModal() {
    this.voiceRecordModal?.open();
  }

  liveShare() {
    this.mdlTempAccess.patchValue({
      strSDate: momentJalaali().format('jYYYY/jMM/jDD'),
      strSTime: momentJalaali().format('HH:mm'),
      strEDate: momentJalaali().format('jYYYY/jMM/jDD'),
      strETime: '23:59',
      strMobile: '',
      strPassword: '',
    });
    $(`#${this.obj_Cam.strUnitId}-modal`).modal('show');
  }

  async new_TempAccess() {
    const Stime = document.getElementById('Stime') as any;

    const Etime = document.getElementById('Etime') as any;

    const strSTime = moment(Stime.value.trim(), 'HH:mm').format('HH:mm');

    this.mdlTempAccess.get('strSTime')?.setValue(Stime.value);

    this.mdlTempAccess.get('strETime')?.setValue(Etime.value);

    if (this.mdlTempAccess.invalid)
      return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (
      moment(
        this.mdlTempAccess.get('strSDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(moment(), 'day')
    ) {
      return this.tooltip.showError('تاریخ شروع نمی تواند قبل از امروز باشد');
    }

    if (
      moment(
        this.mdlTempAccess.get('strEDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(moment(), 'day')
    ) {
      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از امروز باشد');
    }

    if (
      moment(
        this.mdlTempAccess.get('strEDate')?.value.trim(),
        'jYYYY/jMM/jDD',
      ).isBefore(
        moment(
          this.mdlTempAccess.get('strSDate')?.value.trim(),
          'jYYYY/jMM/jDD',
        ),
      )
    ) {
      return this.tooltip.showError(
        'تاریخ پایان نمی تواند قبل از تاریخ شروع باشد',
      );
    }

    if (
      moment(strSTime, 'HH:mm').isBefore(
        moment(moment().format('HH:mm'), 'HH:mm'),
      )
    ) {
      return this.tooltip.showError(
        `ساعت شروع نمی تواند گذشته باشد. (زمان فعلی : ${moment().format('HH:mm')})`,
      );
    }

    if (this.mdlTempAccess.get('strMobile')?.value.length < 10)
      return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    this.otherService.Showspinner();

    const resp = await axios.post(
      `TemporaryAccess_Save`,
      this.otherService.stringNumberToNumber(this.mdlTempAccess.value),
    );

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.tooltip.showError(res.strError);

    this.tooltip.showSuccess('با موفقیت ثبت شد');

    $('#tempAccess-modal').modal('hide');
  }

  takeScreenshot() {
    const video = this.videoRef.nativeElement;
    const canvas = document.createElement('canvas');

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `screenshot-${this.tripId ?? new Date()}.png`;
      link.click();
    }
  }

  async openLink() {
    this.otherService.Showspinner();
    const model = this.otherService.stringNumberToNumber(
      this.mdlTempAccess.value,
    );
    const resp = await axios_2.post(`FleetYar_VehicleliveURL`, model);
    this.otherService.nonespinner();
    let res = resp.data;
    if (res.ISSessionExpired == true) {
      this.tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], {
        queryParams: { error: 'x12333310' },
      });

      return;
    }
    if (res.iResult == 0) return this.tooltip.showError(res.strError);
    window.open(res.LiveURL, '_blank');
  }

  private async terminateStreaming() {
    const video = this.videoRef.nativeElement;

    video.pause();

    this.isPlaying = false;

    const key = {
      strKey: this.gurdService.decrypt(localStorage.getItem('liveKey')!),
    };

    await axios_2.post(
      `CancelVideoStream`,
      this.otherService.stringNumberToNumber(key),
    );

    // this.tooltip.showError('پایان مشاهده فیلم کابین!');

    $.confirm({
      title: 'پایان مشاهده فیلم کابین!',

      content: '',

      type: '',

      buttons: {
        ok: {
          text: 'بستن',

          btnClass: 'btn-secondary',

          keys: ['enter'],
        },
      },
    });
  }
  
}
